// Thirdparty
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

// Theme
import '@styles/index.css'

import calloutBlocks from '@elements/callout-blocks'
import calloutCards from '@elements/callout-cards'
import largeSliderCallout from '@elements/large-slider-callout'
import mediaContent from '@elements/media-content'

import mobileBar from '@components/mobile-bar'
import modal from '@components/modal'
import pageOverlay from '@components/page-overlay'
import scrollReveal from '@components/scroll-reveal'
import scrollTo from '@components/scroll-to'
import siteAnnouncementBar from '@components/site-announcement-bar'
import siteHeader from '@components/site-header'
import siteWidget from '@components/site-widget'
import slideToggle from '@components/slide-toggle'
import styledForm from '@components/styled-form'

import boardPortal from '@sections/board-portal'
import security from '@sections/security'

calloutBlocks.init()
calloutCards.init()
largeSliderCallout.init()
mediaContent.init()

mobileBar.init()
modal.init()
pageOverlay.init()
scrollReveal.init()
scrollTo.init()
siteAnnouncementBar.init()
siteHeader.init()
siteWidget.init()
slideToggle.init()
styledForm.init()

boardPortal.init()
security.init()

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)
})
